import { useEffect, useMemo, useRef, useState } from "react";
import "./App.css";
import { API_BASE, apiFetch, getToken, setToken, clearToken, notify, run, jsonOptions } from "./lib/api";
import { generatePDF, downloadBlob } from "./lib/pdf";
import DishImage from "./components/DishImage";
import Icon from "./components/Icon";
import "./mobile.css";
import AgendaCalendar from "./components/AgendaCalendar";
export default function App() {
  const [query, setQuery] = useState('');
  const [notice, setNotice] = useState(null);
  const [loading, setLoading] = useState(false);
  const [loadError, setLoadError] = useState(false);
  const [loginBusy, setLoginBusy] = useState(false);
  const [saveBusy, setSaveBusy] = useState(false);
  const [pdfBusy, setPdfBusy] = useState(false);
  const operationLock = useRef(false);
  const noticeTimer = useRef(null);
  useEffect(() => {
    const onNotice = event => {
      clearTimeout(noticeTimer.current);
      setNotice(event.detail);
      if (event.detail.kind === 'success') noticeTimer.current = setTimeout(() => setNotice(null), 6000);
    };
    const onExpired = () => {
      setAppSbloccata(false);
      setPasswordScritta('');
    };
    window.addEventListener('mailo:notice', onNotice);
    window.addEventListener('mailo:expired', onExpired);
    return () => {
      clearTimeout(noticeTimer.current);
      window.removeEventListener('mailo:notice', onNotice);
      window.removeEventListener('mailo:expired', onExpired);
    };
  }, []);
  async function login() {
    if (loginBusy) return;
    setLoginBusy(true);
    try {
      const res = await apiFetch(`${API_BASE}/login`, jsonOptions('POST', {
        password: passwordScritta
      }));
      const {
        token
      } = await res.json();
      setToken(token);
      setPasswordScritta('');
      setNotice(null);
      setAppSbloccata(true);
    } finally {
      setLoginBusy(false);
    }
  }
  async function logout() {
    try {
      await apiFetch(`${API_BASE}/logout`, {
        method: 'POST'
      });
    } finally {
      clearToken();
      setAppSbloccata(false);
      setPasswordScritta('');
    }
  }
  function newMenu() {
    setMenuAttivoId(null);
    setMenuScelto({});
    setPiattiPersonalizzati({});
    setSposo('');
    setSposa('');
    setFesteggiato('');
    setData('');
    setOra('');
    setNuovoEvento({});
    setFormInvio({
      opzione: 'No',
      scadenza: '',
      location: '',
      telefono: '',
      email: '',
      persone: '',
      provenienza: '',
      prezzoMenu: '',
      ritoSimbolico: ''
    });
    setMostraMenuSalvati(false);
    setMostraAgenda(false);
    setMode('menu');
    setStep('evento');
  }
  const [step, setStep] = useState("evento");
  const [meseCalendario, setMeseCalendario] = useState(new Date().getMonth());
  const [annoCalendario, setAnnoCalendario] = useState(new Date().getFullYear());
  function vaiAlMesePrecedente() {
    if (meseCalendario === 0) {
      setMeseCalendario(11);
      setAnnoCalendario(prev => prev - 1);
    } else {
      setMeseCalendario(prev => prev - 1);
    }
  }
  function vaiAlMeseSuccessivo() {
    if (meseCalendario === 11) {
      setMeseCalendario(0);
      setAnnoCalendario(prev => prev + 1);
    } else {
      setMeseCalendario(prev => prev + 1);
    }
  }

  // ✅ NEW: modalità (menu/admin)
  const [mode, setMode] = useState("menu"); // "menu" | "admin"
  const [adminTab, setAdminTab] = useState("categorie"); // "categorie" | "piatti"
  const [agenda, setAgenda] = useState([]);
  const [filtroMese, setFiltroMese] = useState("");
  const [filtroAnno, setFiltroAnno] = useState("");
  const [filtroStato, setFiltroStato] = useState("tutti");
  const [appSbloccata, setAppSbloccata] = useState(!!getToken());
  const [passwordScritta, setPasswordScritta] = useState("");
  const [mostraNuovoEvento, setMostraNuovoEvento] = useState(false);
  const [nuovoEvento, setNuovoEvento] = useState({
    location: "",
    nome_evento: "",
    tipo_evento: "",
    data_evento: "",
    opzione: "No",
    scadenza: "",
    telefono: "",
    email: "",
    persone: "",
    prezzo: "",
    provenienza: ""
  });
  const [giornoSelezionato, setGiornoSelezionato] = useState(null);
  const [eventoPopup, setEventoPopup] = useState(null);
  const [popupAperto, setPopupAperto] = useState(false);
  const [salvataggioAgendaInCorso, setSalvataggioAgendaInCorso] = useState(false);
  const [invioEmailInCorso, setInvioEmailInCorso] = useState(false);
  const [formInvio, setFormInvio] = useState({
    opzione: "No",
    scadenza: "",
    location: "",
    tipoEvento: "",
    // Pranzo / Cena
    telefono: "",
    email: "",
    persone: "",
    provenienza: "",
    prezzoMenu: "",
    ritoSimbolico: "" // si / no
  });
  function updateFormInvio(key, value) {
    setFormInvio(prev => ({
      ...prev,
      [key]: value
    }));
  }
  const [filtroCategoria, setFiltroCategoria] = useState("");

  /* EVENTO */
  const [tipoEvento, setTipoEvento] = useState("matrimonio");
  const [sposo, setSposo] = useState("");
  const [sposa, setSposa] = useState("");
  const [festeggiato, setFesteggiato] = useState("");
  const [data, setData] = useState("");
  const [ora, setOra] = useState("");

  /* MENU SALVATI (NUOVO) */
  const [menuSalvati, setMenuSalvati] = useState([]);
  const [menuAttivoId, setMenuAttivoId] = useState(null);
  const [mostraMenuSalvati, setMostraMenuSalvati] = useState(false);
  const [mostraAgenda, setMostraAgenda] = useState(false);

  /* DATA */
  const [categorie, setCategorie] = useState([]);
  const [piatti, setPiatti] = useState([]);
  const [categoriaAttiva, setCategoriaAttiva] = useState(null);
  const [sottocategoriaAttiva, setSottocategoriaAttiva] = useState(null);

  /* MENU */
  const [menuScelto, setMenuScelto] = useState({});
  const [piattiPersonalizzati, setPiattiPersonalizzati] = useState({});

  // ✅ NEW: form admin categorie
  const [catNome, setCatNome] = useState("");
  const [catOrdine, setCatOrdine] = useState(1);
  const [catEditId, setCatEditId] = useState(null);

  // ✅ NEW: form admin piatti
  const [pNome, setPNome] = useState("");
  const [pCatId, setPCatId] = useState("");
  const [pSotto, setPSotto] = useState("");
  const [pDescr, setPDescr] = useState("");
  const [pImg, setPImg] = useState(null);
  const [pImgPreview, setPImgPreview] = useState("");
  const [tipoSottocategoria, setTipoSottocategoria] = useState("esistente");
  const [pEditId, setPEditId] = useState(null);
  const [piattoInModifica, setPiattoInModifica] = useState(null);
  const [editNome, setEditNome] = useState("");
  const [editDescrizione, setEditDescrizione] = useState("");

  /* ----------------------------
     LOAD: localStorage -> fallback file
  ----------------------------- */

  async function reloadData() {
    setLoading(true);
    setLoadError(false);
    try {
      const data = await Promise.all(['categorie', 'piatti', 'menu', 'agenda'].map(async key => {
        const res = await apiFetch(`${API_BASE}/${key}`);
        const rows = await res.json();
        if (!Array.isArray(rows)) throw new Error('Risposta del server non valida.');
        return rows;
      }));
      setCategorie(data[0]);
      setPiatti(data[1]);
      setMenuSalvati(data[2]);
      setAgenda(data[3]);
    } catch (err) {
      setLoadError(true);
      throw err;
    } finally {
      setLoading(false);
    }
  }
  useEffect(() => {
    if (appSbloccata) run(reloadData);
    // Data is reloaded after each successful sign-in.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [appSbloccata]);

  /* HELPERS */
  function titoloEvento() {
    return tipoEvento === "matrimonio" ? `${sposo} & ${sposa}`.trim() : festeggiato.trim();
  }
  async function scaricaPDF() {
    if (operationLock.current) return;
    operationLock.current = true;
    setPdfBusy(true);
    try {
      downloadBlob(await generatePDF(document.getElementById('menu-print')), 'menu_ricevimento.pdf');
    } finally {
      operationLock.current = false;
      setPdfBusy(false);
    }
  }
  function prepareMenu(custom = piattiPersonalizzati) {
    if (!Object.values(menuScelto).some(ids => ids.length)) throw new Error('Seleziona almeno un piatto.');
    if (Object.entries(menuScelto).some(([cat, ids]) => ids.some(id => !categorie.some(c => c.id === Number(cat)) || !piatti.some(p => p.id === id && p.categoria_id === Number(cat))))) throw new Error('Questo menu contiene piatti non più disponibili. Verifica la composizione in Anteprima.');
    const name = titoloEvento();
    if (!name || name === '&') throw new Error('Inserisci i nomi dell’evento.');
    // Distinct events may legitimately have the same name: never silently overwrite them.
    return {
      id: menuAttivoId || Date.now(),
      nome: name,
      evento: {
        tipoEvento,
        sposo,
        sposa,
        festeggiato,
        data,
        ora
      },
      menuScelto,
      piattiPersonalizzati: custom
    };
  }
  async function persistMenu(custom = piattiPersonalizzati) {
    const menu = prepareMenu(custom);
    const res = await apiFetch(menuAttivoId ? `${API_BASE}/menu/${menu.id}` : `${API_BASE}/menu`, jsonOptions(menuAttivoId ? 'PUT' : 'POST', menu));
    const saved = await res.json();
    setMenuAttivoId(saved.id);
    setMenuSalvati(prev => [...prev.filter(m => m.id !== saved.id), saved]);
    return saved;
  }
  async function inviaPdfViaEmail() {
    if (operationLock.current) return;
    operationLock.current = true;
    setInvioEmailInCorso(true);
    try {
      const status = await (await apiFetch(`${API_BASE}/email/status`)).json();
      if (!status.configured) throw new Error('Configura i parametri SMTP sul server per attivare l’invio automatico.');
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formInvio.email)) throw new Error('Inserisci un indirizzo email valido nei dati della proposta.');
      if (!data) throw new Error('Inserisci la data dell’evento.');
      if (formInvio.opzione === 'Si' && !formInvio.scadenza) throw new Error('Inserisci la scadenza dell’opzione.');
      const menu = prepareMenu();
      const pdf = await generatePDF(document.getElementById('menu-print'));
      const associated = agenda.find(e => e.menu_id === menu.id);
      const event = {
        id: nuovoEvento?.id || associated?.id,
        nome_evento: titoloEvento(),
        tipo_evento: tipoEvento,
        data_evento: data,
        location: formInvio.location,
        opzione: formInvio.opzione,
        scadenza: formInvio.scadenza,
        telefono: formInvio.telefono,
        email: formInvio.email,
        persone: formInvio.persone,
        prezzo: formInvio.prezzoMenu,
        provenienza: formInvio.provenienza
      };
      const saved = await (await apiFetch(`${API_BASE}/proposta`, jsonOptions('POST', {
        menu,
        evento: event
      }))).json();
      setMenuAttivoId(saved.menu.id);
      setNuovoEvento(saved.evento);
      setMenuSalvati(prev => [...prev.filter(m => m.id !== saved.menu.id), saved.menu]);
      setAgenda(prev => [...prev.filter(e => e.id !== saved.evento.id), saved.evento]);
      const storageKey = `mailo.email.${saved.evento.id}`;
      let requestId = sessionStorage.getItem(storageKey);
      if (!requestId) {
        requestId = crypto.randomUUID();
        sessionStorage.setItem(storageKey, requestId);
      }
      const form = new FormData();
      form.append('file', pdf, 'menu_ricevimento.pdf');
      form.append('eventId', saved.evento.id);
      form.append('requestId', requestId);
      const receipt = await (await apiFetch(`${API_BASE}/send-email`, {
        method: 'POST',
        body: form
      })).json();
      sessionStorage.removeItem(storageKey);
      notify(receipt.alreadySent ? 'Questa email era già stata inviata: nessun duplicato.' : `Email con PDF affidata al server di posta per ${saved.evento.email}.`, 'success');
    } finally {
      operationLock.current = false;
      setInvioEmailInCorso(false);
    }
  }
  async function salvaMenu() {
    if (operationLock.current) return;
    operationLock.current = true;
    setSaveBusy(true);
    try {
      await persistMenu();
      notify('Menu salvato.', 'success');
    } finally {
      operationLock.current = false;
      setSaveBusy(false);
    }
  }
  function caricaMenu(m) {
    const event = agenda.find(e => e.menu_id === m.id);
    setNuovoEvento(event || {});
    setFormInvio({
      opzione: event?.opzione || 'No',
      scadenza: event?.scadenza || '',
      location: event?.location || '',
      telefono: event?.telefono || '',
      email: event?.email || '',
      persone: event?.persone || '',
      prezzoMenu: event?.prezzo || '',
      provenienza: event?.provenienza || '',
      ritoSimbolico: ''
    });
    setTipoEvento(m.evento.tipoEvento);
    setSposo(m.evento.sposo);
    setSposa(m.evento.sposa);
    setFesteggiato(m.evento.festeggiato);
    setData(m.evento.data);
    setOra(m.evento.ora);
    setMenuScelto(m.menuScelto);
    setPiattiPersonalizzati(m.piattiPersonalizzati || {});
    setMenuAttivoId(m.id);
    setMostraMenuSalvati(false);
    setStep("menu");
  }
  function eliminaMenu(id) {
    if (!window.confirm("Eliminare questo menu?")) return;
    return apiFetch(`${API_BASE}/menu/${id}`, {
      method: "DELETE"
    }).then(() => {
      setMenuSalvati(prev => prev.filter(m => m.id !== id));
      setAgenda(prev => prev.map(e => e.menu_id === id ? { ...e, menu_id: null } : e));
      if (menuAttivoId === id) setMenuAttivoId(null);
    });
  }
  function collegaMenu(evento) {
    if (menuSalvati.length === 0) {
      notify("Non ci sono menu salvati.");
      return;
    }
    const elenco = menuSalvati.map((m, i) => `${i + 1}. ${m.nome}`).join("\n");
    const scelta = prompt(`Scegli il numero del menu da collegare:\n\n${elenco}`);
    if (!scelta) return;
    const indice = Number(scelta) - 1;
    if (isNaN(indice) || indice < 0 || indice >= menuSalvati.length) {
      notify("Scelta non valida");
      return;
    }
    const menu = menuSalvati[indice];
    return apiFetch(`${API_BASE}/agenda/${evento.id}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        ...evento,
        menu_id: menu.id
      })
    }).then(r => r.json()).then(() => {
      setEventoPopup({
        ...evento,
        menu_id: menu.id
      });
      setAgenda(prev => prev.map(e => e.id === evento.id ? {
        ...e,
        menu_id: menu.id
      } : e));
      notify("Menu collegato.", "success");
    });
  }

  // ✅ Mantengo la tua logica ordine, ma se admin inserisce "ordine", lo rispettiamo.
  const categorieOrdinate = useMemo(() => {
    const arr = [...(categorie || [])].filter(Boolean);
    // se qualche ordine manca, lo mettiamo in fondo
    return arr.sort((a, b) => (a.ordine ?? 9999) - (b.ordine ?? 9999));
  }, [categorie]);

  /* PIATTI DELLA CATEGORIA */
  const piattiCategoria = useMemo(() => {
    return (piatti || []).filter(p => p.categoria_id === categoriaAttiva).sort((a, b) => (a.ordine ?? 9999) - (b.ordine ?? 9999));
  }, [piatti, categoriaAttiva]);
  const sottocategorieDisponibili = useMemo(() => {
    if (!pCatId) return [];
    return [...new Set(piatti.filter(p => p.categoria_id === Number(pCatId)).map(p => p.sottocategoria).filter(sc => sc && sc.trim() !== ""))];
  }, [piatti, pCatId]);

  // ✅ PIATTI FILTRATI PER ADMIN
  const piattiAdminFiltrati = useMemo(() => {
    return [...(piatti || [])].filter(p => !filtroCategoria || p.categoria_id === Number(filtroCategoria)).sort((a, b) => {
      if (a.categoria_id !== b.categoria_id) {
        return a.categoria_id - b.categoria_id;
      }
      return (a.ordine ?? 9999) - (b.ordine ?? 9999);
    });
  }, [piatti, filtroCategoria]);

  /* SOTTOCATEGORIE (SE ESISTONO) */
  const sottocategorie = useMemo(() => {
    return [...new Set((piattiCategoria || []).map(p => p.sottocategoria).filter(sc => sc && String(sc).trim() !== ""))];
  }, [piattiCategoria]);

  /* PIATTI FILTRATI */
  const piattiFiltrati = useMemo(() => {
    if (sottocategorie.length === 0) return piattiCategoria;
    if (!sottocategoriaAttiva) return [];
    return piattiCategoria.filter(p => p.sottocategoria === sottocategoriaAttiva);
  }, [piattiCategoria, sottocategorie, sottocategoriaAttiva]);

  /* TOGGLE PIATTO */
  function togglePiatto(catId, piattoId) {
    setMenuScelto(prev => {
      const attuali = prev[catId] || [];
      return {
        ...prev,
        [catId]: attuali.includes(piattoId) ? attuali.filter(id => id !== piattoId) : [...attuali, piattoId]
      };
    });
  }

  /* RENDER DESCRIZIONE */
  function renderDescrizione(testo) {
    if (!testo || typeof testo !== "string") return null;
    return testo.split("\n").map((riga, i) => {
      if (!riga.trim()) return null;
      const clean = riga.replace(/^#+\s*/, "").trim();

      // ELENCHI
      if (riga.startsWith("•")) {
        return <p key={i} className="menu-line">
            {clean.replace(/^•\s*/, "")}
          </p>;
      }

      // SOTTOTITOLO (più elegante, non titolo enorme)
      const isSubtitle = (clean.includes(" – ") || clean.endsWith(":")) && clean.length < 120;
      if (isSubtitle) {
        return <h3 key={i} className="menu-subtitle">
      {clean.replace(/:$/, "")}
    </h3>;
      }
      return <p key={i} className="menu-text">
          {clean}
        </p>;
    });
  }

  /* ----------------------------
     ADMIN: CATEGORIE CRUD
  ----------------------------- */
  function resetCatForm() {
    setCatNome("");
    setCatOrdine(categorieOrdinate.length + 1);
    setCatEditId(null);
  }
  function salvaCategoria(e) {
    e.preventDefault();
    return apiFetch(`${API_BASE}/categorie`, {
      method: catEditId ? "PUT" : "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        id: catEditId,
        nome: catNome,
        ordine: catOrdine
      })
    }).then(() => apiFetch(`${API_BASE}/categorie`)).then(r => r.json()).then(data => {
      setCategorie(data);
      resetCatForm();
    });
  }
  async function eliminaCategoria(catId) {
    if (!window.confirm('Eliminare categoria e piatti collegati? Le categorie usate nei menu salvati sono protette.')) return;
    await apiFetch(`${API_BASE}/categorie/${catId}`, {
      method: 'DELETE'
    });
    await reloadData();
    setMenuScelto(prev => {
      const next = {
        ...prev
      };
      delete next[catId];
      return next;
    });
    setCategoriaAttiva(null);
    setStep('categorie');
    notify('Categoria e piatti collegati eliminati.', 'success');
  }

  /* ----------------------------
     ADMIN: PIATTI CRUD
  ----------------------------- */
  function resetPiattoForm() {
    setPNome("");
    setPCatId("");
    setPSotto("");
    setPDescr("");
    setPImg(null);
    setPImgPreview("");
    setPEditId(null);
  }
  function salvaPiatto(e) {
    e.preventDefault();
    if (!pNome || !pCatId) {
      notify("Nome e categoria obbligatori");
      return;
    }
    const formData = new FormData();
    formData.append("nome", pNome.trim());
    formData.append("categoria_id", pCatId);
    formData.append("sottocategoria", pSotto || "");
    formData.append("descrizione", pDescr || "");
    if (pImg instanceof File) {
      formData.append("immagine", pImg);
    }

    // se stai MODIFICANDO (pEditId) e NON c'è preview => allora vuoi rimuovere
    if (pEditId && !pImgPreview) {
      formData.append("removeImage", "1");
    }
    const url = pEditId ? `${API_BASE}/piatti/${pEditId}` : `${API_BASE}/piatti`;
    const method = pEditId ? "PUT" : "POST";
    return apiFetch(url, {
      method,
      body: formData
    }).then(res => {
      if (!res.ok) throw new Error("Errore backend");
      return apiFetch(`${API_BASE}/piatti`);
    }).then(r => r.json()).then(data => {
      setPiatti(data);
      resetPiattoForm();
      notify("Piatto salvato.", "success");
    }).catch(err => {
      console.error(err);
      notify("❌ Salvataggio fallito");
    });
  }
  function modificaPiatto(p) {
    setPEditId(p.id);
    setPNome(p.nome || "");
    setPCatId(String(p.categoria_id ?? ""));
    setPSotto(p.sottocategoria || "");
    setPDescr(p.descrizione || "");
    setPImg(null);
    setPImgPreview(p.immagine || "");
    setAdminTab("piatti");
  }
  function eliminaPiatto(pId) {
    if (!window.confirm("Eliminare questo piatto?")) return;
    return apiFetch(`${API_BASE}/piatti/${pId}`, {
      method: "DELETE"
    }).then(res => {
      if (!res.ok) throw new Error("Errore eliminazione");

      // ✅ aggiorna SOLO lo state locale
      setPiatti(prev => prev.filter(p => p.id !== pId));

      // pulisce anche il menu scelto
      setMenuScelto(prev => {
        const copy = {
          ...prev
        };
        Object.keys(copy).forEach(catId => {
          copy[catId] = copy[catId].filter(id => id !== pId);
          if (!copy[catId].length) delete copy[catId];
        });
        return copy;
      });
    }).catch(() => notify("❌ Impossibile eliminare il piatto"));
  }
  async function spostaPiatto(piattoId, direzione) {
    const lista = [...piatti].filter(p => p.categoria_id === piatti.find(x => x.id === piattoId)?.categoria_id).sort((a, b) => (a.ordine ?? 9999) - (b.ordine ?? 9999));
    const index = lista.findIndex(p => p.id === piattoId);
    const nuovoIndex = direzione === "su" ? index - 1 : index + 1;
    if (nuovoIndex < 0 || nuovoIndex >= lista.length) return;
    const nuovaLista = [...lista];
    const [spostato] = nuovaLista.splice(index, 1);
    nuovaLista.splice(nuovoIndex, 0, spostato);
    const payload = nuovaLista.map((p, i) => ({
      id: p.id,
      ordine: i + 1
    }));

    // ✅ aggiorna UI

    // ✅ salva su backend
    await apiFetch(`${API_BASE}/piatti/ordine`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(payload)
    });
    setPiatti(prev => prev.map(p => {
      const upd = payload.find(x => x.id === p.id);
      return upd ? {
        ...p,
        ordine: upd.ordine
      } : p;
    }));
  }
  async function spostaCategoria(catId, direzione) {
    // 1️⃣ lista ordinata delle categorie
    const lista = [...categorieOrdinate];

    // 2️⃣ trova posizione attuale
    const index = lista.findIndex(c => c.id === catId);
    const nuovoIndex = direzione === "su" ? index - 1 : index + 1;

    // 3️⃣ blocca se fuori limite
    if (nuovoIndex < 0 || nuovoIndex >= lista.length) return;

    // 4️⃣ sposta realmente
    const nuovaLista = [...lista];
    const [spostata] = nuovaLista.splice(index, 1);
    nuovaLista.splice(nuovoIndex, 0, spostata);

    // 5️⃣ crea payload per backend
    const payload = nuovaLista.map((c, i) => ({
      id: c.id,
      ordine: i + 1
    }));

    // 6️⃣ aggiorna UI subito

    // 7️⃣ salva nel backend
    await apiFetch(`${API_BASE}/categorie/ordine`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(payload)
    });
    setCategorie(prev => prev.map(c => {
      const upd = payload.find(x => x.id === c.id);
      return upd ? {
        ...c,
        ordine: upd.ordine
      } : c;
    }));
  }

  /* ----------------------------
     IMPORT / EXPORT
  ----------------------------- */
  async function exportJSON() {
    const backup = await (await apiFetch(`${API_BASE}/backup`)).json();
    downloadBlob(new Blob([JSON.stringify(backup, null, 2)], {
      type: 'application/json'
    }), `maiolo-backup-${formatDateLocal(new Date())}.json`);
    notify('Backup dati scaricato. Conserva anche la cartella uploads per le immagini.', 'success');
  }
  async function importJSONFile(file) {
    if (!file) return;
    if (file.size > 9 * 1024 * 1024) throw new Error('Backup troppo grande (massimo 9 MB).');
    const parsed = JSON.parse(await file.text());
    if (!Array.isArray(parsed.categorie) || !Array.isArray(parsed.piatti)) throw new Error('Backup non valido: categorie e piatti devono essere elenchi.');
    const current = await (await apiFetch(`${API_BASE}/backup`)).json();
    const full = Array.isArray(parsed.menu) && Array.isArray(parsed.agenda);
    if (!window.confirm(full ? 'Sostituire categorie, piatti, menu e agenda con questo backup? Verrà conservata una copia dei dati attuali.' : 'Sostituire categorie e piatti? Menu e agenda rimangono e i collegamenti saranno verificati.')) return;
    await apiFetch(`${API_BASE}/backup/import`, jsonOptions('POST', {
      revision: current.revision,
      data: parsed
    }));
    await reloadData();
    newMenu();
    notify('Importazione salvata sul server.', 'success');
  }
  const agendaFiltrata = useMemo(() => {
    const oggi = formatDateLocal(new Date());
    const lista = Array.isArray(agenda) ? agenda : [];
    return lista.filter(e => {
      // 🟢 Confermati
      if (filtroStato === "confermato" && e.opzione === "Si") return false;

      // 🟡 Opzioni attive
      if (filtroStato === "opzione") {
        if (e.opzione !== "Si") return false;
        if (e.scadenza && e.scadenza < oggi) return false;
      }

      // 🔴 Opzioni scadute
      if (filtroStato === "scaduto") {
        if (e.opzione !== "Si") return false;
        if (!e.scadenza || e.scadenza >= oggi) return false;
      }
      const d = new Date(`${e.data_evento}T12:00:00`);
      const mese = d.getMonth() + 1;
      const anno = d.getFullYear();
      if (filtroMese && Number(filtroMese) !== mese) return false;
      if (filtroAnno && Number(filtroAnno) !== anno) return false;
      return true;
    }).sort((a, b) => new Date(a.data_evento) - new Date(b.data_evento));
  }, [agenda, filtroMese, filtroAnno, filtroStato]);
  function formatDateLocal(date) {
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, "0");
    const d = String(date.getDate()).padStart(2, "0");
    return `${y}-${m}-${d}`;
  }
  const noticeView = notice && <div className={`app-notice ${notice.kind}`} role={notice.kind === 'error' ? 'alert' : 'status'}>
    <span>{notice.message}</span><button type="button" aria-label="Chiudi notifica" onClick={(...args) => run(() => (() => setNotice(null))(...args))}>×</button>
  </div>;
  if (!appSbloccata) return <main className="login-page">{noticeView}
    <form className="login-card" onSubmit={(...args) => run(() => (e => {
      e.preventDefault();
      run(login);
    })(...args))}>
      <div className="login-monogram">M</div><p className="eyebrow">MAIOLO · RICEVIMENTI</p>
      <h1>Benvenuto</h1><p>Menu, proposte e appuntamenti in un unico spazio.</p>
      <label htmlFor="admin-password">Password amministratore</label>
      <input id="admin-password" type="password" autoComplete="current-password" required value={passwordScritta} onChange={(...args) => run(() => (e => setPasswordScritta(e.target.value))(...args))} />
      <button disabled={loginBusy} type="submit">{loginBusy ? 'Accesso…' : 'Accedi'}</button>
    </form></main>;
  if (loading || loadError) return <main className="login-page">{noticeView}<div className="login-card">
    <h1>{loading ? 'Caricamento…' : 'Dati non disponibili'}</h1>
    <p>{loading ? 'Sto recuperando menu e agenda.' : 'Controlla la connessione e riprova.'}</p>
    {!loading && <button onClick={(...args) => run(() => (() => run(reloadData))(...args))}>Riprova</button>}
    <button className="back-btn" onClick={(...args) => run(() => (() => run(logout))(...args))}>Esci</button>
  </div></main>;

  /* ----------------------------
     UI
  ----------------------------- */
  const oggi = formatDateLocal(new Date());
  const activeView = mode === 'admin' ? 'catalog' : mostraAgenda ? 'agenda' : mostraMenuSalvati ? 'saved' : 'home';
  const navItems = [{
    id: 'home',
    icon: 'home',
    label: 'Proposta'
  }, {
    id: 'saved',
    icon: 'menu',
    label: 'Menu'
  }, {
    id: 'agenda',
    icon: 'calendar',
    label: 'Agenda'
  }, {
    id: 'catalog',
    icon: 'catalog',
    label: 'Catalogo'
  }];
  function navigate(view) {
    setQuery('');
    setMode(view === 'catalog' ? 'admin' : 'menu');
    setMostraAgenda(view === 'agenda');
    setMostraMenuSalvati(view === 'saved');
    if (view === 'agenda') setStep('evento');
  }
  const unresolvedSelections = Object.entries(menuScelto).flatMap(([cat, ids]) => ids.filter(id => !categorie.some(c => c.id === Number(cat)) || !piatti.some(p => p.id === id && p.categoria_id === Number(cat))).map(id => ({ cat, id })));
  const pageTitle = activeView === 'catalog' ? 'Il tuo catalogo.' : activeView === 'agenda' ? 'Ogni evento, al suo posto.' : activeView === 'saved' ? 'Le tue creazioni.' : step === 'evento' ? 'Il prossimo evento inizia qui.' : step === 'menu' ? 'Pronto per fare colpo.' : 'Componi un’esperienza.';
  const pageSubtitle = activeView === 'catalog' ? 'Organizza categorie, piatti e immagini.' : activeView === 'agenda' ? 'Appuntamenti, opzioni e conferme. Tutto sotto controllo.' : activeView === 'saved' ? 'Riprendi un menu e rendilo speciale.' : 'Dai primi dettagli al menu perfetto, un passo alla volta.';
  return <>
    <div className="app">
      {noticeView}
      <header className="workspace-header">
        <button className="wordmark" onClick={() => navigate('home')} aria-label="Maiolo, vai alla proposta"><span className="brand-mark">m.</span><span>maiolo<small>EVENT STUDIO</small></span></button>
        <nav className="workspace-nav" aria-label="Navigazione principale">
          {navItems.map(item => <button key={item.id} className={activeView === item.id ? 'active' : ''} onClick={() => navigate(item.id)} aria-current={activeView === item.id ? 'page' : undefined}><Icon name={item.icon} /><span>{item.label}</span></button>)}
        </nav>
        <button className="logout-icon" aria-label="Esci dall’account" onClick={() => run(logout)}><Icon name="logout" /></button>
      </header>
      <section className="workspace-heading">
        <div><p className="section-kicker">IL TUO SPAZIO DI LAVORO</p><h1>{pageTitle}</h1><p>{pageSubtitle}</p></div>
        <button className="create-action" onClick={() => {
          if (!Object.values(menuScelto).some(x => x.length) || window.confirm('Iniziare un nuovo menu? Salva prima le modifiche che vuoi conservare.')) newMenu();
        }}><Icon name="plus" /><span>Nuova proposta</span></button>
      </section>
      {activeView === 'home' && step === 'evento' && <section className="overview-strip" aria-label="Riepilogo">
        <button onClick={() => navigate('saved')}><span className="metric-icon"><Icon name="menu" /></span><span><strong>{menuSalvati.length}</strong><small>Menu salvati</small></span><Icon name="arrow" size={16} /></button>
        <button onClick={() => navigate('agenda')}><span className="metric-icon amber"><Icon name="calendar" /></span><span><strong>{agenda.filter(e => e.data_evento >= oggi).length}</strong><small>Prossimi eventi</small></span><Icon name="arrow" size={16} /></button>
        <button onClick={() => navigate('catalog')}><span className="metric-icon mauve"><Icon name="catalog" /></span><span><strong>{piatti.length}</strong><small>Piatti in catalogo</small></span><Icon name="arrow" size={16} /></button>
      </section>}
      {activeView === 'home' && <div className="builder-progress" aria-label="Passaggi della proposta">
        {[['evento', 'Evento'], ['categorie', 'Piatti'], ['menu', 'Anteprima']].map(([id, label], i) => <button key={id} className={step === id || (id === 'categorie' && step === 'piatti') ? 'current' : ''} onClick={() => setStep(id)} aria-current={step === id ? 'step' : undefined}><span>{i + 1}</span>{label}</button>)}
        <small>{Object.values(menuScelto).flat().length} piatti scelti</small>
      </div>}
      {(activeView === 'saved' || activeView === 'agenda' || step === 'piatti') && <div className="search-field"><Icon name="search" /><input aria-label="Cerca" placeholder={activeView === 'agenda' ? 'Cerca un evento o un cliente…' : activeView === 'saved' ? 'Cerca nei menu salvati…' : 'Cerca un piatto…'} value={query} onChange={e => setQuery(e.target.value)} />{query && <button aria-label="Cancella ricerca" onClick={() => setQuery('')}>×</button>}</div>}
      {mode === "menu" && mostraMenuSalvati && <div className="panel">
    <h2>Menu salvati</h2>

    {!menuSalvati.length && <p className="admin-muted">Nessun menu salvato.</p>}

    {menuSalvati.filter(m => m.nome.toLowerCase().includes(query.toLowerCase())).map(m => <div key={m.id} className="card">
        <strong>{m.nome}</strong>
        <div className="admin-muted">
          {m.evento.data} — ore {m.evento.ora}
        </div>

        <button className="menu-btn" onClick={(...args) => run(() => (() => caricaMenu(m))(...args))}>
          ✏️ Modifica
        </button>

        <button className="danger-btn" onClick={(...args) => run(() => (() => eliminaMenu(m.id))(...args))}>
          🗑️ Elimina
        </button>
      </div>)}
  </div>}
      {mostraAgenda && step === "evento" && <div className="panel">

        <h2>Agenda / Scadenze</h2><p className="admin-muted">{agenda.length} eventi salvati · {agenda.filter(e => !e.data_evento).length} con data da definire</p>

        <AgendaCalendar agenda={agenda} mese={meseCalendario} anno={annoCalendario} onPrevMonth={vaiAlMesePrecedente} onNextMonth={vaiAlMeseSuccessivo} onDayClick={eventi => {
          setFiltroMese("");
          setFiltroAnno("");
          if (!eventi.length) return;
          setGiornoSelezionato(eventi);
          setEventoPopup(eventi[0]);
          setPopupAperto(true);
        }} />
        <div className="agenda-filters">
  {/* FILTRO STATO */}
  <div className="agenda-filter-group">
    <button className={filtroStato === "tutti" ? "pill active" : "pill"} onClick={(...args) => run(() => (() => setFiltroStato("tutti"))(...args))}>
      Tutti
    </button>

    <button className={filtroStato === "confermato" ? "pill green active" : "pill green"} onClick={(...args) => run(() => (() => setFiltroStato("confermato"))(...args))}>
      🟢 Confermati
    </button>

    <button className={filtroStato === "opzione" ? "pill yellow active" : "pill yellow"} onClick={(...args) => run(() => (() => setFiltroStato("opzione"))(...args))}>
      🟡 Opzioni
    </button>

    <button className={filtroStato === "scaduto" ? "pill red active" : "pill red"} onClick={(...args) => run(() => (() => setFiltroStato("scaduto"))(...args))}>
      🔴 Scaduti
    </button>
  </div>

  {/* FILTRO MESE / ANNO */}
  <div className="agenda-filter-group">
    <select value={filtroMese} onChange={(...args) => run(() => (e => setFiltroMese(e.target.value))(...args))}>
      <option value="">Tutti i mesi</option>
      {[...Array(12)].map((_, i) => <option key={i} value={i + 1}>
          {new Date(0, i).toLocaleString("it-IT", {
                  month: "long"
                })}
        </option>)}
    </select>

    <select value={filtroAnno} onChange={(...args) => run(() => (e => setFiltroAnno(e.target.value))(...args))}>
      <option value="">Tutti gli anni</option>
      {[...new Set(agenda.map(e => e.data_evento ? new Date(e.data_evento).getFullYear() : null))].filter(Boolean).sort().map(a => <option key={a} value={a}>{a}</option>)}
    </select>
  </div>
        </div>



        <button className="menu-btn" style={{
          marginBottom: 16
        }} onClick={(...args) => run(() => (() => {
          setNuovoEvento({
            nome_evento: '',
            tipo_evento: 'matrimonio',
            data_evento: '',
            location: '',
            opzione: 'No',
            scadenza: '',
            telefono: '',
            email: '',
            persone: '',
            prezzo: '',
            provenienza: ''
          });
          setMostraNuovoEvento(true);
        })(...args))}>
  ➕ Aggiungi evento
        </button>

        {!agenda.length && <div className="agenda-empty"><Icon name="calendar" size={32} /><h3>La tua agenda è pronta</h3><p>Non ci sono ancora eventi salvati. Tocca “Aggiungi evento” per inserire il primo appuntamento.</p></div>}

        {agendaFiltrata.filter(e => `${e.nome_evento} ${e.email}`.toLowerCase().includes(query.toLowerCase())).map(e => <div key={e.id} className="card agenda-card">
          <div className="admin-muted">
  🎉 Tipo evento:{" "}
  {e.tipo_evento === "matrimonio" ? "💍 Matrimonio" : e.tipo_evento ? "🎈 Altro evento" : "-"}
          </div>


    <strong>{e.nome_evento}</strong>

    <div className="admin-muted">
      📅 {e.data_evento || "Data da definire"}
    </div>

    <div>
  Stato: {e.opzione === "Si" && e.scadenza && e.scadenza < oggi ? "🔴 Opzione scaduta" : e.opzione === "Si" ? "🟡 Opzione" : "🟢 Confermato"}

  {e.opzione === "Si" && e.scadenza && <> — scade {e.scadenza}</>}
          </div>

    <div className="admin-muted">
      📞 {e.telefono || "-"} • ✉️ {e.email || "-"}
    </div>

    <div className="admin-muted">
📍 Location: {e.location || "-"} <br />
      👥 Persone: {e.persone || "-"} <br />
      💶 Prezzo: {e.prezzo ? `${e.prezzo} €` : "-"} <br />
      🧭 Provenienza: {e.provenienza || "-"}
    </div>

    {/* ✅ AZIONI */}
    <div className="agenda-actions">

            <button className="menu-btn" onClick={(...args) => run(() => (() => {
              setNuovoEvento(e);
              setMenuAttivoId(null);
              setMenuScelto({});
              setPiattiPersonalizzati({});
              setTipoEvento(e.tipo_evento || "altro");
              if ((e.tipo_evento || "") === "matrimonio") {
                const parts = (e.nome_evento || "").split("&");
                setSposo(parts[0]?.trim() || "");
                setSposa(parts[1]?.trim() || "");
                setFesteggiato("");
              } else {
                setFesteggiato(e.nome_evento || "");
                setSposo("");
                setSposa("");
              }
              setData(e.data_evento || "");
              setOra("");
              setFormInvio({
                opzione: e.opzione || "No",
                scadenza: e.scadenza || "",
                location: e.location || "",
                telefono: e.telefono || "",
                email: e.email || "",
                persone: e.persone || "",
                provenienza: e.provenienza || "",
                prezzoMenu: e.prezzo || "",
                ritoSimbolico: ""
              });
              setMostraAgenda(false);
              setStep("categorie");
            })(...args))}>
📄 Nuovo menu
            </button>
     <button className="menu-btn" style={{
              display: "inline-flex",
              padding: "10px 18px",
              fontSize: "14px",
              maxWidth: "100%"
            }} onClick={(...args) => run(() => (() => {
              setNuovoEvento({
                id: e.id,
                nome_evento: e.nome_evento,
                tipo_evento: e.tipo_evento || "",
                data_evento: e.data_evento,
                location: e.location || "",
                opzione: e.opzione,
                scadenza: e.scadenza || "",
                telefono: e.telefono || "",
                email: e.email || "",
                persone: e.persone || "",
                prezzo: e.prezzo || "",
                provenienza: e.provenienza || ""
              });
              setMostraNuovoEvento(true);
            })(...args))}>
  ✏️ Modifica
            </button>


      <button className="danger-btn" onClick={(...args) => run(() => (async () => {
              if (!window.confirm("Eliminare questo evento?")) return;
              const res = await apiFetch(`${API_BASE}/agenda/${e.id}`, {
                method: "DELETE"
              });
              if (!res.ok) {
                notify("Errore eliminazione evento");
                return;
              }

              // ricarica agenda dal server
              const r = await apiFetch(`${API_BASE}/agenda`);
              const data = await r.json();
              setAgenda(data);
            })(...args))}>
        🗑️ Elimina
      </button>
    </div>
  </div>)}



    <p className="admin-muted">
      Qui vedrai opzioni, scadenze ed eventi confermati.
    </p>
   <button className="back-btn" onClick={(...args) => run(() => (() => {
          setMostraAgenda(false);
          setStep("evento"); // 👈 TORNA DAVVERO INDIETRO
        })(...args))}>
  ← Indietro
        </button>

  </div>}


      {/* ----------------------------
          ADMIN PANEL
       ----------------------------- */}
      {mode === "admin" && <div className="panel panel-admin">
          <div className="admin-topbar">
            <div className="tabs">
              <button className={`tab ${adminTab === "categorie" ? "active" : ""}`} onClick={(...args) => run(() => (() => setAdminTab("categorie"))(...args))}>
                Categorie
              </button>
           <button className={`tab ${adminTab === "piatti" ? "active" : ""}`} onClick={(...args) => run(() => (() => {
              setAdminTab("piatti");
              setFiltroCategoria("");
            })(...args))}>
  Piatti
            </button>

            </div>

            <div className="admin-actions">
              <button className="menu-btn" onClick={(...args) => run(() => exportJSON(...args))}>
                ⬇️ Export JSON
              </button>

              <label className="import-btn">
                ⬆️ Import JSON
                <input type="file" accept="application/json" style={{
                display: "none"
              }} onChange={(...args) => run(() => (e => importJSONFile(e.target.files?.[0]))(...args))} />
              </label>

            </div>
          </div>

          {/* ADMIN: CATEGORIE */}
          {adminTab === "categorie" && <div className="admin-grid">
              <div className="admin-col">
                <h2 className="admin-title">
                  {catEditId ? "Modifica categoria" : "Nuova categoria"}
                </h2>

                <form className="admin-form" onSubmit={(...args) => run(() => salvaCategoria(...args))}>
                  <input placeholder="Nome categoria" value={catNome} onChange={(...args) => run(() => (e => setCatNome(e.target.value))(...args))} aria-label="Nome categoria" />
                  <input type="number" placeholder="Ordine" value={catOrdine} onChange={(...args) => run(() => (e => setCatOrdine(e.target.value))(...args))} min={1} aria-label="Ordine" />

                  <div className="admin-form-actions">
                    <button type="submit" className="menu-btn">
                      {catEditId ? "💾 Salva" : "➕ Aggiungi"}
                    </button>
                    {catEditId && <button type="button" className="back-btn" onClick={(...args) => run(() => resetCatForm(...args))}>
                        Annulla
                      </button>}
                  </div>
                </form>
              </div>

              <div className="admin-col">
                <h2 className="admin-title">Elenco categorie</h2>

                <div className="admin-list">
                  {categorieOrdinate.map(c => <div key={c.id} className="admin-row">
                      <div>
                        <strong>{c.nome}</strong>
                        <div className="admin-muted">Ordine: {c.ordine ?? "-"}</div>
                      </div>

                    <div className="admin-row-actions">
  <button className="back-btn" onClick={(...args) => run(() => (() => spostaCategoria(c.id, "su"))(...args))}>
    ↑
  </button>

  <button className="back-btn" onClick={(...args) => run(() => (() => spostaCategoria(c.id, "giu"))(...args))}>
    ↓
  </button>

  <button className="danger-btn" onClick={(...args) => run(() => (() => {
                    if (window.confirm("Eliminare categoria e TUTTI i piatti collegati?")) {
                      eliminaCategoria(c.id);
                    }
                  })(...args))}>
    🗑️
  </button>
                </div>

                    </div>)}
                  {!categorieOrdinate.length && <p className="admin-muted">Nessuna categoria.</p>}
                </div>
              </div>
            </div>}

          {/* ADMIN: PIATTI */}
          {adminTab === "piatti" && <div className="admin-grid">
              <div className="admin-col">
                <h2 className="admin-title">
                  {pEditId ? "Modifica piatto" : "Nuovo piatto"}
                </h2>

               <form className="admin-form" onSubmit={(...args) => run(() => salvaPiatto(...args))}>

  {/* NOME PIATTO */}
  <input type="text" placeholder="Nome del piatto" value={pNome} onChange={(...args) => run(() => (e => setPNome(e.target.value))(...args))} required aria-label="Nome del piatto" />

  {/* CATEGORIA */}
  <select value={pCatId} onChange={(...args) => run(() => (e => {
                setPCatId(e.target.value);
                setPSotto("");
                setTipoSottocategoria("esistente");
              })(...args))}>
    <option value="">-- Seleziona categoria --</option>
    {categorieOrdinate.map(c => <option key={c.id} value={c.id}>
        {c.nome}
      </option>)}
  </select>

  {/* SCELTA SOTTOCATEGORIA */}
  <div className="admin-form-row">
    <label className="radio-option">
      <input type="radio" name="tipoSottocategoria" checked={tipoSottocategoria === "esistente"} onChange={(...args) => run(() => (() => setTipoSottocategoria("esistente"))(...args))} />
      <span>Usa sottocategoria esistente</span>
    </label>

    <label className="radio-option">
      <input type="radio" name="tipoSottocategoria" checked={tipoSottocategoria === "nuova"} onChange={(...args) => run(() => (() => setTipoSottocategoria("nuova"))(...args))} />
      <span>Crea nuova sottocategoria</span>
    </label>
  </div>

  {/* INPUT SOTTOCATEGORIA */}
  {tipoSottocategoria === "esistente" ? <select value={pSotto} onChange={(...args) => run(() => (e => setPSotto(e.target.value))(...args))}>
      <option value="">-- Seleziona sottocategoria --</option>
      {sottocategorieDisponibili.map(sc => <option key={sc} value={sc}>{sc}</option>)}
    </select> : <input placeholder="Nuova sottocategoria" value={pSotto} onChange={(...args) => run(() => (e => setPSotto(e.target.value))(...args))} aria-label="Nuova sottocategoria" />}

  {/* DESCRIZIONE */}
  <textarea placeholder={`Descrizione (usa INVIO per andare a capo)
Es:
Un Viaggio di Gusto:
• Pane fragrante
• Grissini`} value={pDescr} onChange={(...args) => run(() => (e => setPDescr(e.target.value))(...args))} rows={8} />

              {/* IMMAGINE */}
              <input type="file" accept="image/*" onChange={(...args) => run(() => (e => {
                const file = e.target.files?.[0];
                if (!file) return;
                setPImg(file);
                setPImgPreview(URL.createObjectURL(file)); // preview immediata
              })(...args))} />

              {pImg instanceof File && <small className="admin-muted">
    Immagine caricata ({Math.round(pImg.size / 1024)} KB)
  </small>}


  {/* AZIONI */}
  <div className="admin-form-actions">
    <button type="submit" className="menu-btn">
      {pEditId ? "💾 Salva" : "➕ Aggiungi"}
    </button>

    {pEditId && <button type="button" className="back-btn" onClick={(...args) => run(() => resetPiattoForm(...args))}>
        Annulla
      </button>}
  </div>

            </form>


                {/* preview */}
                {(pNome || pDescr || pImg) && <div className="admin-preview">
                    <h3>Anteprima</h3>
                    <div className="card elegant-row">
                      <div className="elegant-content">
                        <h3 className="elegant-title">{pNome || "Nome piatto"}</h3>
                        <div className="elegant-desc">{renderDescrizione(pDescr)}</div>
                      </div>
                  {pImgPreview && <div style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: 8,
                  alignItems: "flex-end"
                }}>
    <img src={pImgPreview} alt="preview" className="elegant-thumb" loading="lazy" />

    <button type="button" className="danger-btn" onClick={(...args) => run(() => (() => {
                    setPImg(null);
                    setPImgPreview("");
                  })(...args))}>
      🗑️ Rimuovi immagine
    </button>
  </div>}


                    </div>
                  </div>}
              </div>

              <div className="admin-col">
                <h2 className="admin-title">Elenco piatti</h2>

            {/* 🔽 FILTRO PER CATEGORIA */}
  <div style={{
              marginBottom: "16px"
            }}>
    <select value={filtroCategoria} onChange={(...args) => run(() => (e => setFiltroCategoria(e.target.value))(...args))}>
      <option value="">Tutte le categorie</option>
      {categorieOrdinate.map(c => <option key={c.id} value={c.id}>
          {c.nome}
        </option>)}
    </select>
  </div>

                <div className="admin-list">
            {piattiAdminFiltrati.map(p => {
                const cat = categorieOrdinate.find(c => c.id === p.categoria_id);
                return <div key={p.id} className="admin-row">
      <div>
        <strong>{p.nome}</strong>
        <div className="admin-muted">
          {cat ? cat.nome : "Categoria?"}
          {p.sottocategoria ? ` • ${p.sottocategoria}` : ""}
        </div>
      </div>

      <div className="admin-row-actions">
        <button className="back-btn" onClick={(...args) => run(() => (() => spostaPiatto(p.id, "su"))(...args))}>
          ↑
        </button>

        <button className="back-btn" onClick={(...args) => run(() => (() => spostaPiatto(p.id, "giu"))(...args))}>
          ↓
        </button>

        <button className="back-btn" onClick={(...args) => run(() => (() => modificaPiatto(p))(...args))}>
          ✏️
        </button>

        <button className="danger-btn" onClick={(...args) => run(() => (() => {
                      if (window.confirm("Eliminare questo piatto?")) {
                        eliminaPiatto(p.id);
                      }
                    })(...args))}>
          🗑️
        </button>
      </div>
    </div>;
              })}


                  {!piattiAdminFiltrati.length && <p className="admin-muted">Nessun piatto in questa categoria.</p>}

                </div>
              </div>
            </div>}
        </div>}

      {/* ----------------------------
          MENU FLOW (TUO, QUASI IDENTICO)
       ----------------------------- */}
  {mode === "menu" && !mostraMenuSalvati && !mostraAgenda && <>

          {/* EVENTO */}
          {step === 'evento' && <div className="event-layout">
            <section className="panel event-main">
              <div className="form-section-title"><span className="section-number">01</span><div><h2>Parliamo dell’evento</h2><p>I dettagli che rendono unica la tua proposta.</p></div></div>
              <div className="form-grid">
                <label className="full-width">Tipo di evento<select value={tipoEvento} onChange={e => setTipoEvento(e.target.value)}><option value="matrimonio">Matrimonio</option><option value="altro">Altro evento</option></select></label>
                {tipoEvento === 'matrimonio' ? <><label>Nome sposo<input placeholder="Es. Luca" value={sposo} onChange={e => setSposo(e.target.value)} aria-label="Es. Luca" /></label><label>Nome sposa<input placeholder="Es. Anna" value={sposa} onChange={e => setSposa(e.target.value)} aria-label="Es. Anna" /></label></> : <label className="full-width">Nome evento o festeggiato<input placeholder="Come si chiama l’evento?" value={festeggiato} onChange={e => setFesteggiato(e.target.value)} aria-label="Come si chiama l’evento?" /></label>}
                <label>Data<input type="date" value={data} onChange={e => setData(e.target.value)} /></label>
                <label>Orario<input type="time" value={ora} onChange={e => setOra(e.target.value)} /></label>
                <label className="full-width">Location<input placeholder="Dove si svolgerà?" value={formInvio.location} onChange={e => updateFormInvio('location', e.target.value)} aria-label="Dove si svolgerà?" /></label>
              </div>
              <details className="event-details"><summary>Ospiti, budget e stato dell’evento<span>＋</span></summary><div className="form-grid">
                <label>Ospiti<input type="number" min="1" placeholder="Es. 80" value={formInvio.persone} onChange={e => updateFormInvio('persone', e.target.value)} aria-label="Es. 80" /></label>
                <label>Prezzo a persona (€)<input inputMode="decimal" placeholder="Es. 90" value={formInvio.prezzoMenu} onChange={e => updateFormInvio('prezzoMenu', e.target.value)} aria-label="Es. 90" /></label>
                <label>Stato<select value={formInvio.opzione} onChange={e => updateFormInvio('opzione', e.target.value)}><option value="No">Confermato</option><option value="Si">In opzione</option></select></label>
                {formInvio.opzione === 'Si' && <label>Scadenza opzione<input type="date" value={formInvio.scadenza} onChange={e => updateFormInvio('scadenza', e.target.value)} /></label>}
                <label className="full-width">Come ci hanno conosciuto<input placeholder="Es. passaparola, Instagram…" value={formInvio.provenienza} onChange={e => updateFormInvio('provenienza', e.target.value)} aria-label="Es. passaparola, Instagram…" /></label>
              </div></details>
            </section>
            <aside className="event-side">
              <section className="panel contact-panel"><div className="contact-icon"><Icon name="mail" size={24} /></div><h2>Un invito a stupire.</h2><p>Quando il menu è pronto, invialo direttamente al cliente con il PDF allegato.</p>
                <label>Email del cliente<input type="email" placeholder="nome@esempio.it" autoComplete="email" value={formInvio.email} onChange={e => updateFormInvio('email', e.target.value)} aria-label="nome@esempio.it" /></label>
                <label>Telefono<input type="tel" placeholder="+39" autoComplete="tel" value={formInvio.telefono} onChange={e => updateFormInvio('telefono', e.target.value)} aria-label="+39" /></label>
                <small>L’email partirà solo quando tocchi “Invia email con PDF”.</small>
              </section>
              <button className="continue-action" onClick={() => {
              if (tipoEvento === 'matrimonio' ? !sposo.trim() || !sposa.trim() : !festeggiato.trim()) {
                notify('Inserisci i nomi dell’evento.');
                return;
              }
              setQuery('');
              setStep('categorie');
            }}>Scegli i piatti<Icon name="arrow" /></button>
            </aside>
          </div>}

          {/* CATEGORIE */}
          {step === "categorie" && <div className="panel grid">
              {categorieOrdinate.map(c => <div key={c.id} className="card category-card" role="button" tabIndex={0} onKeyDown={e => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              setCategoriaAttiva(c.id);
              setSottocategoriaAttiva(null);
              setStep("piatti");
            }
          }} onClick={(...args) => run(() => (() => {
            setCategoriaAttiva(c.id);
            setQuery('');
            setSottocategoriaAttiva(null);
            setStep("piatti");
          })(...args))}>
                  <span className="category-symbol"><Icon name="catalog" /></span><strong>{c.nome}</strong><small>{piatti.filter(p => p.categoria_id === c.id).length} piatti disponibili</small><Icon name="arrow" size={18} />
                </div>)}
            </div>}

          {/* PIATTI */}
          {step === "piatti" && <div className="panel">
              {/* TABS SOTTOCATEGORIE */}
              {sottocategorie.length > 0 && <div className="tabs">
                  {sottocategorie.map(sc => <button key={sc} className={`tab ${sottocategoriaAttiva === sc ? "active" : ""}`} onClick={(...args) => run(() => (() => setSottocategoriaAttiva(sc))(...args))}>
                      {sc}
                    </button>)}
                </div>}

              {/* LISTA PIATTI */}
              {piattiFiltrati.filter(p => `${p.nome} ${p.descrizione}`.toLowerCase().includes(query.toLowerCase())).map(p => {
            const selezionato = menuScelto[categoriaAttiva]?.includes(p.id);
            return <div key={p.id} className="card elegant-row">
                    <div className="elegant-content">
                      <h3 className="elegant-title">{p.nome}</h3>
                      <div className="elegant-desc">
                        {renderDescrizione(p.descrizione)}
                      </div>

                      <button className={`select-btn ${selezionato ? "selected" : ""}`} onClick={(...args) => run(() => (() => togglePiatto(categoriaAttiva, p.id))(...args))}>
                        {selezionato ? "✓ Selezionato" : "Seleziona"}
                      </button>
                    </div>

              {p.immagine && <DishImage src={p.immagine} alt={p.nome} className="elegant-thumb" loading="lazy" />}


                  </div>;
          })}
            </div>}

          {/* MENU */}
          {step === "menu" && <div className="menu-card" id="menu-print">
          {unresolvedSelections.length > 0 && <div className="recovery-note screen-only" role="status">Questo menu contiene {unresolvedSelections.length} riferimenti a piatti non presenti nel catalogo attuale. Verifica la composizione prima di salvare o inviare.<br /><button onClick={() => { if (window.confirm('Rimuovere dal menu i riferimenti ai piatti non più disponibili?')) setMenuScelto(prev => Object.fromEntries(Object.entries(prev).map(([cat, ids]) => [cat, ids.filter(id => !unresolvedSelections.some(x => x.cat === cat && x.id === id))]).filter(([, ids]) => ids.length))); }}>Rimuovi riferimenti mancanti</button></div>}
              <img src="/logo.png" alt="Maiolo" className="menu-logo" />

              <h1 className="menu-title">Menu</h1>

              <p className="menu-subtitle">
                <span className="menu-names">{titoloEvento()}</span>
                <br />
                <span className="menu-date">
                  {data} — ore {ora}
                </span>
              </p>

              {categorieOrdinate.map(cat => {
            const scelti = menuScelto[cat.id];
            if (!scelti?.length) return null;
            return <section key={cat.id} className="menu-section">
      <h2>{cat.nome}</h2>

     {scelti.map(id => (piatti || []).find(x => x.id === id)).sort((a, b) => (a?.ordine ?? 9999) - (b?.ordine ?? 9999)).map(p => {
                if (!p) return null;
                if (!p) return null;
                return <div key={p.id} className="menu-item">

            <div className="menu-item-text">

  <div style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      gap: "10px"
                    }}>
    <h3>
      {piattiPersonalizzati[p.id]?.nome || p.nome}
    </h3>

    <button type="button" className="back-btn" onClick={(...args) => run(() => (() => {
                        setPiattoInModifica(p);
                        setEditNome(piattiPersonalizzati[p.id]?.nome || p.nome);
                        setEditDescrizione(piattiPersonalizzati[p.id]?.descrizione || p.descrizione || "");
                      })(...args))}>
      ✏️
    </button>
  </div>

  {renderDescrizione(piattiPersonalizzati[p.id]?.descrizione ?? p.descrizione)}

                  </div>

            {p.immagine && <DishImage src={p.immagine} alt={p.nome} className="menu-thumb" />}
          </div>;
              })}
    </section>;
          })}

             <div className="menu-footer">
  <button disabled={saveBusy || invioEmailInCorso || pdfBusy} onClick={(...args) => run(() => (() => run(salvaMenu))(...args))}>{saveBusy ? "Salvataggio…" : "💾 Salva Menu"}</button>

  <button onClick={(...args) => run(() => (() => window.print())(...args))}>
    🖨️ Stampa / Salva PDF
  </button>

  <button disabled={pdfBusy || invioEmailInCorso} onClick={(...args) => run(() => (() => run(scaricaPDF))(...args))}>
    {pdfBusy ? "Creazione PDF…" : "📄 Scarica PDF"}
  </button>

            <button disabled={invioEmailInCorso || pdfBusy || saveBusy} onClick={(...args) => run(() => (() => run(inviaPdfViaEmail))(...args))}>
  {invioEmailInCorso ? 'Invio in corso…' : '📧 Invia email con PDF'}
            </button>


          </div>

            </div>}
        </>}
    </div>

    
    {/* ===== MODALE NUOVO EVENTO AGENDA ===== */}
    {mostraNuovoEvento && <div style={{
      position: "fixed",
      inset: 0,
      background: "rgba(0,0,0,0.5)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 9999
    }} className="modal-overlay">
        <div style={{
        background: "#fff",
        padding: 20,
        borderRadius: 8,
        width: 360
      }} className="modal-sheet">
          <h3>Nuovo evento agenda</h3>

          <input placeholder="Nome evento" value={nuovoEvento.nome_evento} onChange={(...args) => run(() => (e => setNuovoEvento({
          ...nuovoEvento,
          nome_evento: e.target.value
        }))(...args))} aria-label="Nome evento" />
        <label>Tipo evento</label>
        <select value={nuovoEvento.tipo_evento} onChange={(...args) => run(() => (e => setNuovoEvento({
          ...nuovoEvento,
          tipo_evento: e.target.value
        }))(...args))}>
  <option value="">-- seleziona --</option>
  <option value="matrimonio">💍 Matrimonio</option>
  <option value="altro">🎉 Altro evento</option>
        </select>

          <input type="date" value={nuovoEvento.data_evento} onChange={(...args) => run(() => (e => setNuovoEvento({
          ...nuovoEvento,
          data_evento: e.target.value
        }))(...args))} />
        <input type="text" placeholder="Location (es. Villa Contressi)" value={nuovoEvento.location} onChange={(...args) => run(() => (e => setNuovoEvento({
          ...nuovoEvento,
          location: e.target.value
        }))(...args))} aria-label="Location (es. Villa Contressi)" />


          <select value={nuovoEvento.opzione} onChange={(...args) => run(() => (e => setNuovoEvento({
          ...nuovoEvento,
          opzione: e.target.value
        }))(...args))}>
            <option value="No">Confermato</option>
            <option value="Si">Opzione</option>
          </select>

          {nuovoEvento.opzione === "Si" && <input type="date" placeholder="Scadenza opzione" value={nuovoEvento.scadenza} onChange={(...args) => run(() => (e => setNuovoEvento({
          ...nuovoEvento,
          scadenza: e.target.value
        }))(...args))} aria-label="Scadenza opzione" />}

          <input placeholder="Telefono" value={nuovoEvento.telefono} onChange={(...args) => run(() => (e => setNuovoEvento({
          ...nuovoEvento,
          telefono: e.target.value
        }))(...args))} aria-label="Telefono" />

          <input placeholder="Email" value={nuovoEvento.email} onChange={(...args) => run(() => (e => setNuovoEvento({
          ...nuovoEvento,
          email: e.target.value
        }))(...args))} aria-label="Email" />
        <input type="number" placeholder="Numero persone" value={nuovoEvento.persone} onChange={(...args) => run(() => (e => setNuovoEvento({
          ...nuovoEvento,
          persone: e.target.value
        }))(...args))} aria-label="Numero persone" />

        <input type="text" placeholder="Prezzo indicativo (€)" value={nuovoEvento.prezzo} onChange={(...args) => run(() => (e => setNuovoEvento({
          ...nuovoEvento,
          prezzo: e.target.value
        }))(...args))} aria-label="Prezzo indicativo (€)" />

        <input type="text" placeholder="Provenienza (Email, Instagram, Passaparola...)" value={nuovoEvento.provenienza} onChange={(...args) => run(() => (e => setNuovoEvento({
          ...nuovoEvento,
          provenienza: e.target.value
        }))(...args))} aria-label="Provenienza (Email, Instagram, Passaparola...)" />


          <div style={{
          display: "flex",
          gap: 8,
          marginTop: 12
        }}>
            <button onClick={(...args) => run(() => (() => setMostraNuovoEvento(false))(...args))}>
              Annulla
            </button>

          <button className="menu-btn" disabled={salvataggioAgendaInCorso} onClick={(...args) => run(() => (async () => {
            if (salvataggioAgendaInCorso) return;
            setSalvataggioAgendaInCorso(true);
            try {
              const method = nuovoEvento.id ? "PUT" : "POST";
              const url = nuovoEvento.id ? `${API_BASE}/agenda/${nuovoEvento.id}` : `${API_BASE}/agenda`;
              await apiFetch(url, {
                method,
                headers: {
                  "Content-Type": "application/json"
                },
                body: JSON.stringify(nuovoEvento)
              });
              const r = await apiFetch(`${API_BASE}/agenda`);
              const data = await r.json();
              setAgenda(data);
              setMostraNuovoEvento(false);
            } finally {
              setSalvataggioAgendaInCorso(false);
            }
          })(...args))}>
  {salvataggioAgendaInCorso ? "Salvataggio..." : "Salva"}
          </button>

          </div>
        </div>
      </div>}
    {popupAperto && eventoPopup && <div style={{
      position: "fixed",
      inset: 0,
      background: "rgba(0,0,0,0.45)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 9999
    }} className="modal-overlay">
    <div style={{
        width: 500,
        maxWidth: "95%",
        background: "#fff",
        borderRadius: 14,
        padding: 25
      }} className="modal-sheet">
      <h2>Dettagli evento</h2>
        {giornoSelezionato?.length > 1 && <div className="day-event-tabs">{giornoSelezionato.map(e => <button key={e.id} className={eventoPopup.id === e.id ? 'active' : ''} onClick={() => setEventoPopup(e)}>{e.nome_evento}</button>)}</div>}

      <p><b>🎉 Evento:</b> {eventoPopup.nome_evento}</p>
      <p><b>📅 Data:</b> {eventoPopup.data_evento}</p>
      <p><b>📍 Location:</b> {eventoPopup.location || "-"}</p>
      <p><b>👥 Persone:</b> {eventoPopup.persone || "-"}</p>
      <p><b>📞 Telefono:</b> {eventoPopup.telefono || "-"}</p>
      <p><b>✉️ Email:</b> {eventoPopup.email || "-"}</p>

      <div style={{
          marginTop: 25,
          borderTop: "1px solid #eee",
          paddingTop: 18
        }}>
  <p>
  <b>📄 Menu collegato:</b>{" "}
  {eventoPopup.menu_id ? "Presente" : "Nessun menu collegato"}
          </p>

          {!eventoPopup.menu_id && <button className="menu-btn" onClick={(...args) => run(() => (() => collegaMenu(eventoPopup))(...args))}>
    📎 Collega menu
  </button>}

  <div style={{
            display: "flex",
            justifyContent: "flex-end",
            gap: 10,
            marginTop: 20
          }}>
    {eventoPopup.menu_id && <button className="menu-btn" onClick={(...args) => run(() => (() => {
              console.log("menu_id evento:", eventoPopup.menu_id);
              console.log("menuSalvati:", menuSalvati);
              const menuTrovato = menuSalvati.find(m => Number(m.id) === Number(eventoPopup.menu_id));
              if (!menuTrovato) {
                notify("Menu collegato non trovato in archivio");
                return;
              }
              setPopupAperto(false);
              setMostraAgenda(false);
              caricaMenu(menuTrovato);
            })(...args))}>
        📂 Apri menu
      </button>}

    <button className="back-btn" onClick={(...args) => run(() => (() => setPopupAperto(false))(...args))}>
      Chiudi
    </button>
  </div>
        </div>

    </div>
  </div>}
    {piattoInModifica && <div style={{
      position: "fixed",
      inset: 0,
      background: "rgba(0,0,0,0.5)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 9999
    }} className="modal-overlay">
    <div style={{
        background: "#fff",
        padding: 20,
        borderRadius: 10,
        width: 650,
        maxWidth: "95%"
      }} className="modal-sheet">
      <h2>Modifica piatto</h2>

      <label>Nome</label>

      <input style={{
          width: "100%",
          marginBottom: 15
        }} value={editNome} onChange={(...args) => run(() => (e => setEditNome(e.target.value))(...args))} />

      <label>Descrizione</label>

      <textarea rows={10} style={{
          width: "100%"
        }} value={editDescrizione} onChange={(...args) => run(() => (e => setEditDescrizione(e.target.value))(...args))} />

      <div style={{
          display: "flex",
          justifyContent: "flex-end",
          gap: 10,
          marginTop: 20
        }}>
        <button onClick={(...args) => run(() => (() => setPiattoInModifica(null))(...args))}>
          Annulla
        </button>

        <button className="menu-btn" onClick={(...args) => run(() => (async () => {
            const nuovoPersonalizzati = {
              ...piattiPersonalizzati,
              [piattoInModifica.id]: {
                ...(piattiPersonalizzati[piattoInModifica.id] || {}),
                nome: editNome,
                descrizione: editDescrizione
              }
            };
            if (operationLock.current) return;
            operationLock.current = true;
            try {
              await persistMenu(nuovoPersonalizzati);
              setPiattiPersonalizzati(nuovoPersonalizzati);
            } finally {
              operationLock.current = false;
            }
            setPiattoInModifica(null);
          })(...args))}>
          Salva
        </button>
      </div>
    </div>
  </div>}
  </>;
}
